import { useQuery } from "react-query";
import { TApiCollectionResponse } from "../../../../../api/apiCoreV2.types";
import {
  ExtractFnReturnType,
  QueryConfig,
} from "../../../../../lib/react-query";
import { apiEmpleo } from "../../../../../util/ApiEmpleo";
import { TCandidateAttachment } from "../types/candidateAttachment.types";
import { candidateAttachmentKeys } from "./candidateAttachments.query-keys";

export type TApiListCandidateAttachmentsParams = {
  candidateId: string;
  page: number;
};

export const apiListCandidateAttachments = async (
  params: TApiListCandidateAttachmentsParams
) => {
  const res: TApiCollectionResponse<TCandidateAttachment> =
    await apiEmpleo.get(`candidatos/${params.candidateId}/attachments`, {
      params: { page: params.page },
    });

  return res;
};

type QueryFnType = typeof apiListCandidateAttachments;

type TUseCandidateAttachmentsOptions = {
  params: TApiListCandidateAttachmentsParams;
  config?: QueryConfig<QueryFnType>;
};

export const useCandidateAttachments = ({
  params,
  config,
}: TUseCandidateAttachmentsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    keepPreviousData: true,
    ...config,
    queryKey: candidateAttachmentKeys.listForCandidate(
      params.candidateId,
      params.page
    ),
    queryFn: () => apiListCandidateAttachments(params),
  });
};
